const SETTINGS = {
    warnings: false,
    useReactotron: false,
    reduxLogging: false,
};

export default SETTINGS;
